export default __webpack_public_path__ + "static/sdk-gifs-86e75507b9f1aafe3eecefc5e55e5f6e.gif";